import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { useTheme } from '../../theming/useTheme';
import { Ad } from '../ads/Ad';
import { AdditionalStyleSheet } from '../components.utils';
import { getHeaderHeights, primaryHeaderHeights } from '../components/navigation/header/header.utils';
import { BaseUnit } from '../../theming/baseUnitDefinition';

interface PostSidebarThemeProps {
  baseUnit: BaseUnit;
}

interface PostSideBarDataProps {
  adId1: string | null;
  adId2: string | null;
  isSecondaryHeaderEnabled: boolean;
}

const createStyle = (baseUnit: BaseUnit) => {
  return StyleSheet.create({
    sidebar: {
      gridRowEnd: 'span 2',
      [MEDIA_BREAKPOINTS.large]: {
        gridRowEnd: 'span 2',
        padding: `${baseUnit}px`,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.small]: {
        display: 'none',
      },
    },
  });
};

const createAdditionalStyleForStickyAd = (headerHeights: typeof primaryHeaderHeights, baseUnit: BaseUnit) => {
  return StyleSheet.create({
    style: {
      position: 'sticky',
      paddingTop: `${baseUnit}px`,
      [MEDIA_BREAKPOINTS.large]: {
        top: headerHeights.large,
      },
      [MEDIA_BREAKPOINTS.medium]: {
        top: headerHeights.medium,
      },
      [MEDIA_BREAKPOINTS.small]: {
        top: headerHeights.small,
      },
    },
  }) as AdditionalStyleSheet;
};

export const PostSidebar: React.FunctionComponent<PostSideBarDataProps> = props => {
  const { adId1, adId2, isSecondaryHeaderEnabled } = props;
  const { baseUnit } = useTheme<PostSidebarThemeProps>();
  const style = createStyle(baseUnit);
  const headerHeights = getHeaderHeights(isSecondaryHeaderEnabled);
  return (
    <div className={css(style.sidebar)}>
      <Ad id={adId1} />
      <Ad id={adId2} additionalStyle={createAdditionalStyleForStickyAd(headerHeights, baseUnit)} />
    </div>
  );
};
